<template>
  <div>
    <el-row id="tabBarNav">
      <el-col>
        <el-form :inline="true">
          <el-form-item label="关键字:">
            <el-input
              v-model="filters.keyWord"
              placeholder="请输入姓名/手机号/身份证号"
              clearable
              @clear="handleClear"
              style="width:300px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称:">
            <el-input
              v-model="filters.socialUnitName"
              placeholder="请输入单位名称"
              clearable
              @clear="handleClear"
            ></el-input>
          </el-form-item>
          <el-form-item label="综合状态:">
            <el-select
              v-model="filters.totalScoreQualified"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in totalScoreQualifiedList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="当前在考项目:">
            <el-select
              v-model="filters.stationId"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in stationList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交成绩时间:">
            <el-date-picker
								v-model="filters.examDate"
								type="daterange"
								format="yyyy 年 MM 月 dd 日"
								value-format="yyyy-MM-dd"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
						>
						</el-date-picker>
           
          </el-form-item>
          
          <!-- <el-form-item label="是否取证:">
            <el-select
              v-model="filters.isPass"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      border
      v-loading="listLoading"
      highlight-current-row
      :header-row-style="{ height: '47px' }"
      style="width: 100%; margin-bottom: 20px"
        @current-change="selectCurrentRow"
    >
      <el-table-column
        prop="StudentName"
        label="姓名"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="CardNo"
        label="身份证号"
        align="center"
        min-width="110"
      ></el-table-column>
      <el-table-column
        prop="UnitName"
        label="单位名称"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="StationName"
        label="当前在考项目"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="CallPhone"
        label="拨打119电活(秒)"
        align="center"
        min-width="120"
      >
        <template v-slot="scope">
            <span style="color:green;cursor:pointer;" v-if="scope.row.CallPhoneQualified" @click="openDialog(scope.row,1)">{{scope.row.CallPhone}}</span>
            <span style="color:red;cursor:pointer;" v-else  @click="openDialog(scope.row,1)">{{scope.row.CallPhone}}</span>
        </template>
      </el-table-column>
      
      <el-table-column
        prop="FireExtinguisher"
        label="灭火器(秒)"
        align="center"
        min-width="120"
      >
       <template v-slot="scope">
            <span style="color:green;cursor:pointer;" v-if="scope.row.FireExtinguisherQualified"  @click="openDialog(scope.row,2)">{{scope.row.FireExtinguisher}}</span>
            <span style="color:red;cursor:pointer;" v-else  @click="openDialog(scope.row,2)">{{scope.row.FireExtinguisher}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Hose"
        label="消防软管卷盘(秒)"
        align="center"
        min-width="120"
      >
      <template v-slot="scope">
            <span style="color:green;cursor:pointer;" v-if="scope.row.HoseQualified" @click="openDialog(scope.row,3)">{{scope.row.Hose}}</span>
            <span style="color:red;cursor:pointer;" v-else @click="openDialog(scope.row,3)">{{scope.row.Hose}}</span>
      </template>
      </el-table-column>
     
      <el-table-column
        prop="FireCock"
        label="室内消火栓(秒)"
        align="center"
        min-width="120"
      >
       <template v-slot="scope">
            <span style="color:green;cursor:pointer;" v-if="scope.row.FireCockQualified" @click="openDialog(scope.row,4)">{{scope.row.FireCock}}</span>
            <span style="color:red;cursor:pointer;" v-else @click="openDialog(scope.row,4)">{{scope.row.FireCock}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="SelfRescuer"
        label="过滤式消防自教呼吸器(秒)"
        align="center"
        min-width="120"
      >
        <template v-slot="scope">
            <span style="color:green;cursor:pointer;" v-if="scope.row.SelfRescuerQualified" @click="openDialog(scope.row,5)">{{scope.row.SelfRescuer}}</span>
            <span style="color:red;cursor:pointer;" v-else @click="openDialog(scope.row,5)">{{scope.row.SelfRescuer}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="TotalScoreQualified"
        label="综合状态"
        align="center"
        min-width="120"
      >
      <template v-slot="scope">
            <el-tag type="success" v-if="scope.row.TotalScoreQualified">合格</el-tag>
            <el-tag type="danger" v-else>不合格</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="UpdateTime"
        label="提交成绩时间"
        align="center"
        min-width="110"
      ></el-table-column>
    
    </el-table>
    <!--底部工具条-->
    <el-col
      :span="24"
      class="pageBar"
      style="padding-bottom: 22px; margin-top: -12px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
    <!--新增预览弹窗 -->
    <el-dialog
      :visible.sync="previewDialogVisible"
      width="30%"
      top="5vh"
      custom-class="pdf-preview-dialog"
     
    >
      <div>
          <h4 v-if="type==1">检验项目:拨打119电话</h4>
          <h4 v-if="type==2">检验项目:灭火器</h4>
          <h4 v-if="type==3">检验项目:消防软管卷盘</h4>
          <h4 v-if="type==4">检验项目:室内消火栓</h4>
          <h4 v-if="type==5">检验项目:过滤式消防自教呼吸器</h4>
      </div>
      <div style="margin-top:10px;">
          <div v-if="type==1">
            <span style="margin-right:20px"> 合格标准:{{currentRow?.CallPhoneQualifiedScore}}秒</span>
              是否合格:
              <span v-if="currentRow?.CallPhoneQualified">合格</span>
              <span v-else>不合格</span>
          </div>
          <div v-if="type==2">
             <span style="margin-right:20px"> 合格标准: {{currentRow?.FireExtinguisherQualifiedScore}}秒</span>
                是否合格:
                <span v-if="currentRow?.FireExtinguisherQualified">合格</span>
                <span v-else>不合格</span>
          </div>
          <div v-if="type==3">
            <span style="margin-right:20px"> 合格标准:{{currentRow?.HoseQualifiedScore}}秒</span>
              是否合格:
              <span v-if="currentRow?.HoseQualified">合格</span>
              <span v-else>不合格</span>
          </div>
           <div v-if="type==4">
             <span style="margin-right:20px"> 合格标准:{{currentRow?.FireCockQualifiedScore}}秒</span>
                是否合格:
                <span v-if="currentRow?.FireCockQualified">合格</span>
                <span v-else>不合格</span>
          </div>
           <div v-if="type==5">
             <span style="margin-right:20px"> 合格标准: {{currentRow?.SelfRescuerQualifiedScore}}秒</span>
              是否合格:
              <span v-if="currentRow?.SelfRescuerQualified">合格</span>
              <span v-else>不合格</span>
          </div>
      </div>
      <div style="margin-top:10px;">
          <div v-if="type==1">
            <span>操作时长:{{currentRow?.CallPhone}}秒</span>
            <span style="margin-left:20px;">记录员:{{currentRow?.CallPhoneTeacherName}}</span>
          </div>
          <div v-if="type==2">
            <span>操作时长:{{currentRow?.FireExtinguisher}}秒</span>
            <span style="margin-left:20px;">记录员:{{currentRow?.FireExtinguisherTeacherName}}</span>
          </div>
          <div v-if="type==3">
            <span>操作时长:{{currentRow?.Hose}}秒</span>
            <span style="margin-left:20px;">记录员:{{currentRow?.HoseTeacherName}}</span>
          </div>
          <div v-if="type==4">
            <span>操作时长:{{currentRow?.FireCock}}秒</span>
            <span style="margin-left:20px;">记录员:{{currentRow?.FireCockTeacherName}}</span>
          </div>
          <div v-if="type==5">
            <span>操作时长:{{currentRow?.SelfRescuer}}秒</span>
            <span style="margin-left:20px;">记录员:{{currentRow?.SelfRescuerTeacherName}}</span>
          </div>
      </div>
      <div style="margin-top:10px;">
         <div v-if="type==1">
            <span>记录时间:{{currentRow?.CallPhoneTime}}</span>
        </div>
         <div v-if="type==2">
            <span>记录时间:{{currentRow?.FireExtinguisherTime}}</span>
        </div>
         <div v-if="type==3">
            <span>记录时间:{{currentRow?.HoseTime}}</span>
        </div>
        <div v-if="type==4">
            <span>记录时间:{{currentRow?.FireCockTime}}</span>
        </div>
        <div v-if="type==5">
            <span>记录时间:{{currentRow?.SelfRescuerTime}}</span>
        </div>
      </div>
    </el-dialog>
     <el-dialog
      title="修改实操成绩状态"
      :visible.sync="OverallStatusDialog"
      width="30%"
      top="5vh"
     
     
    >
     <el-form :model="dialogForm"   label-width="150px" enctype="multipart/form-data">
          <el-form-item label='综合状态:'>
                <el-radio-group v-model="dialogForm.totalScoreQualified">
                        <el-radio :label="true">合格</el-radio>
                        <el-radio :label="false">不合格</el-radio>
                  </el-radio-group>
          </el-form-item>
            
     </el-form>
     <div slot="footer" class="dialog-footer">
                <el-button @click.native="OverallStatusDialog = false">取消</el-button>
                <el-button  type="primary" @click.native="OverallStatusSumbit" >确定</el-button>
            </div>


    </el-dialog>
  </div>
</template>
<script>
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
  getStudentExamEnrollInfoPracticalPageApi,
  getStationTradeList,
  exportStudentExamEnrollInfoPracticalApi,
  updatePracticalTotalScoreQualified
} from "../../api/api";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      filters: {
        stationId: undefined, //岗位ID
        keyWord: undefined, //搜索关键字
        socialUnitName: undefined, //单位名称
       // isPass: 1, //是否取证 0:未取证 1:已取证
        examDate:"",
        totalScoreQualified:undefined
      },
      stationList: [],
      tradeList: [],
      options: [
        { value: 1, name: "已取证" },
        { value: 0, name: "未取证" },
      ],
      buttonList: [],
      tableData: [],
      listLoading: false,
      totalScoreQualifiedList:[
        {
          Id:true,
          Name:'合格'
        },
         {
          Id:false,
          Name:'不合格'
        }
      ],
      previewDialogVisible:false,
      type:"",
      currentRow:null,
      OverallStatusDialog:false,
      dialogForm:{
        totalScoreQualified:true
      }
    };
  },
  methods: {
    // 获取行业名称
    async getTradeTypeData() {
      let params = {
        dataType: 0,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.tradeList = res.data.Response;
      }
    },
    //获取岗位名称
    async getStationList() {
      let params = {
        dataType: 1,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.stationList = res.data.Response;
      }
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    // 清除input框，重新获取数据
    handleClear() {
      this.getDataList();
    },
    // 获取分页列表
    getDataList() {
      let params = {
        pageIndex: this.pages.pageIndex, //当前页
        pageSize: this.pages.pageSize, //每页条数
        stationId: this.filters.stationId, //岗位ID
        keyWord: this.filters.keyWord, //搜索关键字
        socialUnitName: this.filters.socialUnitName, //单位名称
        //isPass: this.filters.isPass, //是否取证 0:未取证 1:已取证
        startTime:this.filters.examDate?this.filters.examDate[0]:"",
        endTime:this.filters.examDate?this.filters.examDate[1]:"",
        totalScoreQualified: this.filters.totalScoreQualified, //岗位ID
      };
      this.listLoading = true;
      getStudentExamEnrollInfoPracticalPageApi(params).then((res) => {
        let result = res.data;
        if (result.Success) {
          this.tableData = result.Response.Data;
          // this.tableData = [
          //   {
          //     CallPhone:15,
          //     CallPhoneTeacherName:"郭康伟",
          //     CallPhoneQualified:false,
          //     CallPhoneQualifiedScore:20,
          //     CallPhoneTime:'2025年6月',
          //     FireExtinguisher:20,
          //     FireExtinguisherTeacherName:"小黄",
          //     FireExtinguisherQualified:true,
          //     Hose:15,
          //     HoseTeacherName:'小红',
          //     HoseQualified:true,
          //     FireCock:22,
          //     FireCockTeacherName:"小绿",
          //     FireCockQualified:true,
          //     SelfRescuer:18,
          //     SelfRescuerTeacherName:'小邹',
          //     SelfRescuerQualified:false,
          //     TotalScoreQualified:false
          //   }
          // ]
          this.pages.dataCount = result.Response.DataCount;
        } else {
          this.tableData = [];
          this.pages.dataCount = 0;
        }
        this.listLoading = false;
      });
    },
    // 查询
    getListData() {
      this.pages.pageIndex = 1;
      this.pages.pageSize = 20;
      this.getDataList();
    },
  
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getDataList();
    },
    

    // 表格数据分页条数累计
    indexMethod(index) {
      let currentPage = this.pages.pageIndex;
      let pageSize = this.pages.pageSize;
      return index + 1 + (currentPage - 1) * pageSize;
    },
    exportExcel() {
      this.$confirm('确定导出吗？',"提示",{}).then(() => {
        let params = {
          stationId: this.filters.stationId ? this.filters.stationId : undefined, //岗位ID
          keyWord: this.filters.keyWord ? this.filters.keyWord : undefined, //搜索关键字
          socialUnitName: this.filters.socialUnitName
            ? this.filters.socialUnitName
            : undefined, //单位名称
          //isPass: this.filters.isPass ? this.filters.isPass : undefined, //是否取证 0:未取证 1:已取证
          startTime:this.filters.examDate?this.filters.examDate[0]:"",
          endTime:this.filters.examDate?this.filters.examDate[1]:"",
          totalScoreQualified:this.filters.totalScoreQualified,
        };
        exportStudentExamEnrollInfoPracticalApi(params).then((res) => {
          if(res.status==200){
              let fileName  = "实操成绩.xlsx"
              // 创建Blob对象
              let blob = new Blob([res.data], {type: "content-type"})
              // 创建临时链接并触发下载
              const link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileName;
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              // 清理资源
              document.body.removeChild(link);
              window.URL.revokeObjectURL(link.href);
              this.$message.success(res.statusText)
          }else{
            this.$message.warning(res.statusText)
          }
        })
      })
   },
   openDialog(row,type){
      console.log('row',row)
      console.log('type',type)
      this.currentRow = row
      this.type = type
      this.previewDialogVisible = true
   },
   
  updateOverallStatus(){
        console.log('走修改综合')
        if(!this.currentRow){
          this.$message.warning('请选择要修改的数据')
          return;
        }
        this.OverallStatusDialog = true
  },
  OverallStatusSumbit(){
    let params = {
      id:this.currentRow.Id,
      totalScoreQualified:this.dialogForm.totalScoreQualified
    }
    updatePracticalTotalScoreQualified(params).then(res=>{
     console.log('res',res)
     if(res.data.Success){
        this.$message.success(res.data.Message)
        this.getDataList()
        this.OverallStatusDialog = false
     }else{
         this.$message.warning(res.data.Message)
     }
    })
  },
  selectCurrentRow(row){
    console.log('row',row)
    this.currentRow  = row
  }
},

  watch: {
    
  },
  mounted() {
    this.getStationList();
    this.getTradeTypeData();
    this.getListData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);

      

   
  },
};
</script>
<style lang="stylus" scoped>
.el-textarea>>>.el-textarea__inner {
  min-height: 100px !important;
}

#tabBarNav .el-form-item {
  margin-bottom: 8px;
}
</style>
<style>
.el-tooltip__popper {
  max-width: 500px;
}
.pdf-preview-dialog .el-dialog__header {
  padding:0px
}
</style>